import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {PrimeNGConfig} from 'primeng/api';

@Component({
    selector: 'app-component-date-time-picker',
    templateUrl: './date-time-picker.component.html',
    styleUrls: ['./date-time-picker.component.scss']
})
export class DateTimePickerComponent implements OnInit {

    @Input() date: Date | string;
    @Input() minDate: Date = new Date();
    @Input() timeId = 'time';

    @Input() public stringify = false;
    @Input() public showTime = false;
    @Input() public hiddenCalendar = false;
    @Input() public inline = false;

    @Input() public isRange = false;
    rangeDates: Date[];
    @ViewChild('calendar') public calendar;
    @Output() private pickedDate: EventEmitter<any> = new EventEmitter<any>();

    constructor(private config: PrimeNGConfig) {
        config.setTranslation({
            monthNames: [
                'Январь ', 'Февраль ', 'Март ', 'Апрель ', 'Май ', 'Июнь ',
                'Июль ', 'Август ', 'Сентябрь ', 'Октябрь ', 'Ноябрь ', 'Декабрь '
            ],
            dayNamesMin: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
        });
    }

    ngOnInit(): void {
        if (this.stringify && this.date) {
            this.date = new Date(this.date);
        }
    }

    changeDateTime(e, side): void {
        if (this.hiddenCalendar && side === 'outside' && !this.showTime) {
            this.pickedDate.emit(this.isRange ? this.rangeDates : this.date);
        } else if (!this.hiddenCalendar && side === 'inside') {
            this.date = e;
            this.pickedDate.emit(e);
        } else if (this.hiddenCalendar && side === 'inside') {
            this.rangeDates = e;
            this.pickedDate.emit(this.rangeDates);
        }
    }

    click(): void {
        this.calendar.inputfieldViewChild.nativeElement.click();
    }
}
